import { getSectionVisibleActionType } from '@noths/polaris-client-components';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectCurrentImage } from '../modules/selectors';
import { actions } from '../modules/slice';
import {
  PRODUCT_IMAGES_CAROUSEL_VISIBILITY_NAME,
  ProductImagesCarouselExpand,
  ProductImagesCarouselImageClick,
  ProductImagesCarouselImpression,
  ProductImagesCarouselNavigate,
} from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [getSectionVisibleActionType(PRODUCT_IMAGES_CAROUSEL_VISIBILITY_NAME)]: (state) => {
    const numberOfImages = String(state.productImagesCarousel.lastImage + 1);

    sendGAEvent<ProductImagesCarouselImpression>({
      event: 'custom_event',
      event_category: 'Image carousel',
      event_action: 'Impression',
      event_label: numberOfImages,
    });
  },
  [actions.openModal.type]: (_prevState, _nextState, action) => {
    const {
      payload: { location },
    } = action as ReturnType<typeof actions.openModal>;

    sendGAEvent<ProductImagesCarouselExpand>({
      event: 'custom_event',
      event_action: 'Expand image',
      event_category: 'Image carousel',
      event_label: location,
    });
  },
  [actions.setCurrentImage.type]: (prevState, nextState, action) => {
    const {
      payload: { navigationType, location },
    } = action as ReturnType<typeof actions.setCurrentImage>;

    if (location && navigationType === 'click') {
      sendGAEvent<ProductImagesCarouselImageClick>({
        event: 'custom_event',
        event_action: 'Image click',
        event_category: 'Image carousel',
        event_label: location,
      });
    }

    if (location && navigationType === 'swipe') {
      const direction: ProductImagesCarouselNavigate['event_action'] =
        selectCurrentImage(nextState) > selectCurrentImage(prevState)
          ? 'Next image'
          : 'Previous image';

      sendGAEvent(<ProductImagesCarouselNavigate>{
        event: 'custom_event',
        event_action: direction,
        event_category: 'Image carousel',
        event_label: location,
      });
    }
  },
  [actions.nextImage.type]: (_prevState, _nextState, action) => {
    const {
      payload: { location },
    } = action as ReturnType<typeof actions.nextImage>;

    sendGAEvent(<ProductImagesCarouselNavigate>{
      event: 'custom_event',
      event_action: 'Next image',
      event_category: 'Image carousel',
      event_label: location,
    });
  },
  [actions.prevImage.type]: (_prevState, _nextState, action) => {
    const {
      payload: { location },
    } = action as ReturnType<typeof actions.prevImage>;

    sendGAEvent(<ProductImagesCarouselNavigate>{
      event: 'custom_event',
      event_action: 'Previous image',
      event_category: 'Image carousel',
      event_label: location,
    });
  },
};
